"use client";

import * as React from "react";

import Image from "next/image";

import * as AccordionPrimitive from "@radix-ui/react-accordion";

import Plus from "@repo/ui/assets/Plus.svg";
import { cn } from "@repo/ui/lib/utils";

function FooterAccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item data-slot="accordion-item" className={cn("", className)} {...props} />
  );
}

function FooterAccordionTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          "flex flex-1 items-start justify-between gap-4 rounded-md py-1 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>img]:rotate-180",
          className,
        )}
        {...props}
      >
        {children}
        <Image
          width={20}
          height={20}
          src={Plus}
          alt="Plus"
          className="text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200"
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

export { FooterAccordionItem, FooterAccordionTrigger };
